import SelectionInboxGridRow from "./SelectionInboxModel/SelectionInboxGridRow"
import { ObservableFromFetch } from "../ObservableFromFetch"

export default function UpdateStatusToPending(data: SelectionInboxGridRow[]) {
  const tests = data.map((d) => ({
    TestEventID: d.TestEventID,
    MockTestDetailID: d.TestDetailID,
    FormFoxTestAN: d.FormFoxTestAN,
  }))

  const params: string = JSON.stringify(tests)
  return ObservableFromFetch<string>("WorkforceRandomTest/UpdateStatusToPending", params, "put")
}
